// extracted by mini-css-extract-plugin
export default {"button":"Button_button__9wG7V","green":"Button_green__WPASX","gold":"Button_gold__hrcgv","red":"Button_red__DuWnw"};